import Header from "../components/Header";
import Banner from "../components/Banner";
import ErrorPage from "../components/ErrorPage";
import GlobalMenu from "../components/GlobalMenu";
import Footer from "../components/Footer";
import ErrorMarcos from "../../public/images/403_marcos.svg";
import ErrorLeni from "../../public/images/403_Leni.svg";
import ErrorIsko from "../../public/images/403_Isko.svg";
import ErrorPing from "../../public/images/403_Ping.svg";
import ErrorLeody from "../../public/images/403_Leody.svg";
import ErrorManny from "../../public/images/403_Manny.svg";
import styles from "../styles/homepage/Home.module.scss";

const Custom403 = () => {
  const randomImages = () => {
    var images = [],
      graphics = 0;
    images[0] = ErrorMarcos;
    images[1] = ErrorLeni;
    images[2] = ErrorIsko;
    images[3] = ErrorPing;
    images[4] = ErrorLeody;
    images[5] = ErrorManny;
    graphics = Math.floor(Math.random() * images.length);
    return images[graphics];
  };

  return (
    <div className={styles.container}>
      <Header />
      <Banner />
      <GlobalMenu />
      <ErrorPage
        graphics={randomImages()}
        errorMessage="We're sorry, but you do not have access to this resource."
      />
      <Footer />
    </div>
  );
};

export default Custom403;
